export default {
    sort: {
        asc: 'صعودی',
        desc: 'نزولی'
    },
    column: {
        hide: 'پنهان'
    },
    pagination: {
        totalRowsText: 'سطر در مجموع',
        rowsPerPage: 'سطر در صفحه',
        pageOf: 'صفحه {current} از {total}',
        first: 'برو به صفحه اول',
        previous: 'برو به صفحه قبل',
        next: 'برو به صفحه بعد',
        last: 'برو به صفحه آخر'
    },
    search: 'جستجو در تمام ستون‌ها...',
    view: 'نمایش',
    toggleColumns: 'تغییر وضعیت',
    reset: 'بازنشانی',
    noResults: 'نتیجه‌ای یافت نشد.',
    filter: {
        title: 'فیلترها',
        open: 'باز کردن فیلترها',
        available: 'فیلترهای موجود',
        active: 'فعال',
        back: 'بازگشت به فیلترها',
        clear: 'پاک کردن',
        clearAll: 'پاک کردن همه',
        remove: 'حذف فیلتر {filter}',
        searchFields: 'جستجوی فیلترها...',
        searchValues: 'جستجوی مقادیر...',
        noFields: 'فیلتری یافت نشد.',
        selected: 'انتخاب شده',
        noResults: 'نتیجه‌ای یافت نشد.',
        reset: 'بازنشانی فیلترها',
        date: 'تاریخ',
        numberRange: 'بازه شماره',
        numericRules: 'قوانین مبلغ',
        pressEnter: 'برای اعمال Enter بزنید',
        numberFrom: 'شماره از',
        numberTo: 'شماره تا',
        numberResetHint: 'بازنشانی، تاریخ را به امروز تغییر می‌دهد',
        billingView: 'نمای صورتحساب'
    }
} 